import sidePanel from "./sidePanel.json"
import auth from "./auth.json"
import admin from "./admin.json"
import rankChecker from "./rankChecker.json"

const english = {
    "translation": {
        "SidePanel" : sidePanel,
        "Auth" : auth,
        "Admin" : admin,
        "RankChecker":rankChecker
    }
}

export default english